import styled from '~/app/components/styled'
import React from 'react'
import getNolPointsToBeEarned from '~/app/utils/getNolPointsToBeEarned'
import useNolUserLinkageInfo from '~/app/utils/useNolUserLinkageInfo'
import { toPoint } from '~/app/utils/krNumberToString'
import { Typography } from '@yanolja-rnd/ya-com-core'

interface NolBannerProps {
  amountToPay: number
}

const Container = styled.div`
  ${Typography('body2').regular};
  background-color: ${({ theme }) => theme.color.gray50};
  margin-top: 2rem;
  padding: 0 1.6rem;
  display: flex;
  align-items: center;
  height: 3.6rem;
  border-radius: 0.4rem;
`

const HighLighted = styled.mark`
  margin-left: 0.4rem;
  margin-right: 0.4rem;
  ${Typography('body2').bold};
  color: #e31068;
  background: none;
`

const NolBanner: React.FC<NolBannerProps> = ({ amountToPay }) => {
  const { isLinked } = useNolUserLinkageInfo()

  return (
    <>
      <Container>
        NOL 카드 결제 시,
        <HighLighted>
          {isLinked
            ? `최대 ${toPoint(getNolPointsToBeEarned(amountToPay).nolPoints, true)}`
            : '10%'}{' '}
          적립
        </HighLighted>
      </Container>
    </>
  )
}

export default NolBanner
